var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, ModalBody, ModalFoot, ModalHead, Switch, Tabs, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Component } from 'react';
import { Field, Form, reduxForm, } from 'redux-form';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import ColorField from 'components/shared/util/ColorField';
import ReduxFormDixaSwitch from 'components/shared/util/DixaSwitch';
import InputField from 'components/shared/util/InputField';
import SelectField from 'components/shared/util/SelectField';
import { getRequestID } from 'components/shared/util/request';
import DemoWidget from '../../containers/demoWidget';
import styles from './widgetCustomization.module.scss';
export const FORM_NAME = 'chatFlowCustomForm';
/**
 * https://stackoverflow.com/questions/56551644/property-contentwindow-does-not-exist-on-type-htmlelement-sending-from-one-s
 * type guard heck to check if HTMLElement is iframe
 */
export const isIframe = (input) => input !== null && input.tagName === 'IFRAME';
const validate = (values) => {
    const errors = {};
    const localeTypes = [
        'ar',
        'cs-CZ',
        'da',
        'de-DE',
        'el-GR',
        'en-US',
        'es-ES',
        'et-EE',
        'fi',
        'fr-FR',
        'hi-IN',
        'hr-HR',
        'hu-HU',
        'id-ID',
        'is',
        'it-IT',
        'ja-JP',
        'ko-KR',
        'lt-LT',
        'lv-LV',
        'ms-MY',
        'nl',
        'no',
        'pl-PL',
        'pt-PT',
        'ro-RO',
        'ru-RU',
        'sv',
        'th-TH',
        'tr-TR',
        'vi-VN',
        'zh-CN',
    ];
    if (!values) {
        return errors;
    }
    for (const local of localeTypes) {
        if (!values.localizations ||
            !values.localizations[local] ||
            !values.localizations[local].minimized.html_text_online) {
            errors.payload = {
                [local]: {
                    minimized: {
                        html_text_online: 'Required',
                    },
                },
            };
        }
        if (!values.localizations ||
            !values.localizations[local] ||
            !values.localizations[local].minimized.html_text_offline) {
            errors.payload = {
                [local]: {
                    minimized: {
                        html_text_online: 'Required',
                    },
                },
            };
        }
    }
    return errors;
};
const tabs = [
    { id: 'translations', label: 'Translations' },
    { id: 'theme', label: 'Theme / Color' },
    { id: 'widgetPosition', label: 'Widget position' },
];
class WidgetCustomizeModal extends Component {
    constructor(props) {
        var _a;
        super(props);
        const { node: { payload }, } = this.props;
        this.state = {
            selectedLocale: '',
            selectedView: null,
            show_contact_form: false,
            show_widget: false,
            view: (_a = payload === null || payload === void 0 ? void 0 : payload.medium) === null || _a === void 0 ? void 0 : _a.minimized_view.view,
            widgetType: 'medium',
            selectedTab: 'translations',
        };
    }
    componentDidMount() {
        if (this.props.node.nodeType === FlowNodeTypes.WIDGET_CUSTOMIZATION) {
            this.props.nodeWidgetCustomizationLoadPayload({ node: this.props.node });
        }
    }
    handleSaveClick(values) {
        var _a;
        const { node, replaceNode, triggerClose, destroy, resetLocalization } = this.props;
        const { view } = this.state;
        const payload = Object.assign(Object.assign({}, values), { medium: Object.assign(Object.assign({}, values.medium), { minimized_view: {
                    position: values.medium.minimized_view.position,
                    view: view || 'badge',
                } }), nextNodeId: ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.nextNodeId) || getRequestID() });
        const nodeOptions = Object.assign(Object.assign({}, node), { badges: [], icon: 'i-widget-customize', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.WIDGET_CUSTOMIZATION, overlay: [], payload, text: 'Widget Customization' });
        replaceNode(nodeOptions);
        triggerClose();
        destroy();
        resetLocalization();
    }
    changeWidgetTypeShown(widgetType) {
        this.setState({ widgetType }, () => {
            var _a;
            const { currentFormValues } = this.props;
            if ((_a = currentFormValues[widgetType]) === null || _a === void 0 ? void 0 : _a.minimized_view) {
                const position = currentFormValues[widgetType].minimized_view.position;
                this.changeWidgetPosition(widgetType, position);
            }
        });
    }
    changeSelectedView(view) {
        if (view === 'minimized') {
            view = 'minimized_view';
        }
        if (view === 'conversation') {
            view = 'chatbox_view';
        }
        this.setState({ selectedView: view });
    }
    changeSelectedLanguage(selectedLocale) {
        this.setState({ selectedLocale });
    }
    changeWidgetState(payload) {
        if (payload && payload.show_widget) {
            this.setState({ show_widget: payload.show_widget });
        }
        if (payload && payload.show_contact_form) {
            this.setState({ show_contact_form: payload.show_contact_form });
        }
    }
    sendToIframeSmall(iFrameProps) {
        if (document) {
            const ID = 'demo-widget-iframe-wrapper-small';
            this.sendToDixa(ID, iFrameProps);
        }
    }
    sendToIframeMedium(iFrameProps) {
        if (document) {
            const ID = 'demo-widget-iframe-wrapper-medium';
            this.sendToDixa(ID, iFrameProps);
        }
    }
    sendToDixa(id, iFrameProp) {
        const iframe = document.getElementById(id);
        if (isIframe(iframe) && iframe.contentWindow) {
            iframe.contentWindow._dixa(iFrameProp.apiText, iFrameProp.stateText, iFrameProp.targetValue, iFrameProp.contactText);
        }
    }
    changeConversationMinimizedHandler(event) {
        // We use the javascript API to talk with the widget in the iframe.
        // And change the minimized text.
        if (!this.state.selectedLocale) {
            console.error('state selectedLocale is empty string');
            return;
        }
        const iFrameProps = {
            apiText: 'api.setMinimizedText',
            stateText: this.state.selectedLocale,
            targetValue: event.target.value,
        };
        this.sendToIframeMedium(iFrameProps);
        this.sendToIframeSmall(iFrameProps);
    }
    changeContactFormMinimizedHandler(event) {
        // We use the javascript API to talk with the widget in the iframe.
        // And change the minimized text.
        if (!this.state.selectedLocale) {
            console.error('state selectedLocale is empty');
            return;
        }
        const iFrameProps = {
            apiText: 'api.setMinimizedText',
            stateText: this.state.selectedLocale,
            targetValue: event.target.value,
            cantactText: 'contact',
        };
        this.sendToIframeMedium(iFrameProps);
        this.sendToIframeSmall(iFrameProps);
    }
    changeLocalization(checked, local) {
        if (checked) {
            this.props.removeLocalization({ local });
            this.changeLanguage('en-US');
        }
        else {
            this.props.addLocalization({ local });
            this.changeLanguage(local);
        }
    }
    changeWidgetColor(color) {
        const theme = Object.assign(Object.assign({}, this.props.payload.theme), { color });
        const iFrameProps = {
            apiText: 'api.setTheme',
            stateText: JSON.stringify(theme),
        };
        this.sendToIframeMedium(iFrameProps);
        this.sendToIframeSmall(iFrameProps);
    }
    changeWidgetPosition(widgetType, position) {
        if (!this.state.selectedView) {
            console.error('state selectedView is not given.');
            return;
        }
        const iFrameProps = {
            apiText: 'api.setPosition',
            stateText: position,
            targetValue: this.state.selectedView || undefined,
        };
        if (widgetType === 'medium') {
            this.sendToIframeMedium(iFrameProps);
            this.props.change('medium.chatbox_view.position', position);
        }
        else {
            this.sendToIframeSmall(iFrameProps);
            this.props.change('small.chatbox_view.position', position);
        }
    }
    handleStickyChange(isChecked) {
        const view = isChecked ? 'sticky' : 'badge';
        this.setState({ view }, () => {
            const iFrameProps = {
                apiText: 'api.setSticky',
                stateText: view,
            };
            this.sendToIframeMedium(iFrameProps);
        });
    }
    changeLanguage(localValue) {
        const iFrameProps = {
            apiText: 'api.setLanguage',
            stateText: localValue,
        };
        this.changeSelectedLanguage(localValue);
        this.sendToIframeMedium(iFrameProps);
        this.sendToIframeSmall(iFrameProps);
    }
    closeModal() {
        const { destroy, resetLocalization, triggerClose } = this.props;
        destroy();
        resetLocalization();
        triggerClose();
    }
    render() {
        const { payload, node, nodeLabel, handleSubmit } = this.props;
        const widgetSettingsLoaded = payload === null || payload === void 0 ? void 0 : payload.loaded;
        const { view } = this.state;
        const tabsBody = {
            translations: (_jsxs("div", { children: [_jsxs("div", { children: [_jsx("label", Object.assign({ className: styles.languageTitle }, { children: "Supported Languages in the widget" })), _jsx("div", Object.assign({ className: styles.supportedLanguages }, { children: this.props.localizationOptions.map((local, i) => {
                                    if (local.value === 'en-US')
                                        return null;
                                    const checked = this.props.selectedLocalizations.some((selectedLocal) => selectedLocal.value === local.value);
                                    return (_jsxs("div", Object.assign({ className: styles.languageItem }, { children: [_jsx("label", { children: "Disabled" }), _jsx(Switch, { onChange: () => {
                                                    this.changeLocalization(checked, local.value);
                                                }, checked: checked, name: "", value: "" }), _jsx("label", { children: `Enabled ${local.label}` })] }), i));
                                }) }))] }), _jsxs("div", Object.assign({ className: "form-group" }, { children: [_jsx("label", Object.assign({ htmlFor: "" }, { children: "Select Language" })), _jsxs("select", Object.assign({ className: "select form-control", onChange: (e) => {
                                    this.changeLanguage(e.target.value);
                                }, value: this.state.selectedLocale }, { children: [_jsxs("option", Object.assign({ hidden: true, value: "" }, { children: [' ', "- Select a language"] })), this.props.selectedLocalizations.map((option, index) => {
                                        return (_jsx("option", Object.assign({ value: option.value }, { children: option.label }), index));
                                    }), ";"] }))] })), this.state.selectedLocale !== '' ? (_jsx(Field, { displayName: "Conversation form minimized", onChangeAction: this.changeConversationMinimizedHandler, name: `localizations.${this.state.selectedLocale}.minimized.html_text_online`, type: "text", className: "form-control", component: InputField })) : null, this.state.selectedLocale !== '' ? (_jsx(Field, { displayName: "Contact form minimized", onChangeAction: this.changeContactFormMinimizedHandler, name: `localizations.${this.state.selectedLocale}.minimized.html_text_offline`, type: "text", className: "form-control", component: InputField })) : null] })),
            theme: (_jsxs("div", { children: [_jsx(Field, { label: "Theme color", name: "theme.color", onChangeAction: this.changeWidgetColor, className: "form-control theme-color", component: ColorField }), _jsx("br", {}), _jsx("br", {}), _jsx("br", {}), _jsx("br", {}), _jsx("br", {}), _jsx("br", {}), _jsx("br", {}), _jsx("br", {})] })),
            widgetPosition: (_jsxs("div", { children: [_jsxs(Field, Object.assign({ displayName: "Mobile widget position", name: "small.minimized_view.position", className: "form-control", onChangeAction: (position) => {
                            this.changeWidgetPosition('small', position);
                        }, component: SelectField }, { children: [_jsxs("option", Object.assign({ hidden: true, value: "" }, { children: [' ', "- Select a position"] })), this.props.mobilePositionOptions.map((option, index) => {
                                return (_jsx("option", Object.assign({ value: option.value }, { children: option.label }), index));
                            }), ";"] })), _jsxs(Field, Object.assign({ displayName: "Desktop widget position", name: "medium.minimized_view.position", className: "form-control", onChangeAction: (position) => {
                            this.changeWidgetPosition('medium', position);
                        }, component: SelectField }, { children: [_jsxs("option", Object.assign({ hidden: true, value: "" }, { children: [' ', "- Select a position"] })), this.props.desktopPositionOptions.map((option, index) => {
                                return (_jsx("option", Object.assign({ value: option.value }, { children: option.label }), index));
                            }), ";"] })), _jsx(Field, { displayName: "Sticky position", labelB: "Enabled", labelA: "Disabled", onChangeAction: this.handleStickyChange, name: "medium.minimized_view.view", className: "form-control", isChecked: view === 'sticky', component: ReduxFormDixaSwitch, controlled: true, showHelpIcon: true, helpIconTitle: "Sticky position", helpIconText: "Whether the widget should stick the edge of the page." })] })),
        };
        return (_jsx("div", Object.assign({ className: "localization modal-chatflow-holder chat-modal-customize-widget" }, { children: _jsxs(Form, Object.assign({ onSubmit: handleSubmit(this.handleSaveClick) }, { children: [_jsx(ModalHead, { title: nodeLabel, onClose: this.closeModal }), _jsx(ModalBody, { children: _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "300", className: "chat-modal-customize-widget__content" }, { children: [_jsx("div", Object.assign({ className: 'widget-demo-transparent' +
                                        (this.state.widgetType === 'small'
                                            ? ' mobile-transparent'
                                            : '') }, { children: widgetSettingsLoaded && (_jsx(DemoWidget, { hideLanguageButtons: false, changeSelectedView: this.changeSelectedView, changeWidgetState: this.changeWidgetState, changeSelectedLanguage: this.changeSelectedLanguage, changeWidgetTypeShown: this.changeWidgetTypeShown, widgetType: this.state.widgetType })) })), _jsx(Tabs, { selectedId: this.state.selectedTab, tabs: tabs, onChange: (selectedTab) => {
                                        this.setState({ selectedTab });
                                    } }), tabsBody[this.state.selectedTab]] })) }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(this.handleSaveClick), confirmName: getConfirmButtonVerb(node), cancelOnClick: this.closeModal })] })) })));
    }
}
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "handleSaveClick", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "changeWidgetTypeShown", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "changeSelectedView", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "changeSelectedLanguage", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "changeWidgetState", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "sendToIframeSmall", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "sendToIframeMedium", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "sendToDixa", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "changeConversationMinimizedHandler", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "changeContactFormMinimizedHandler", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "changeLocalization", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "changeWidgetColor", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "changeWidgetPosition", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "handleStickyChange", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "changeLanguage", null);
__decorate([
    boundMethod
], WidgetCustomizeModal.prototype, "closeModal", null);
export default reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
    keepDirtyOnReinitialize: false,
    validate,
})(WidgetCustomizeModal);
